/**
 * Analytics - User Events
 * 
 * @atomic - User-related tracking (auth, profile, activity)
 * @modular - User event tracking module
 * 
 * Purpose: Track user authentication, profile actions, and activity
 * Exports: trackSignup, trackLogin, trackProfileAction
 */

import { trackEvent } from './core'

/**
 * Track user signup
 */
export const trackSignup = (method) => {
  trackEvent('User', 'signup', method)
}

/**
 * Track user login
 */
export const trackLogin = (method) => {
  trackEvent('User', 'login', method)
}

/**
 * Track profile-related actions
 */
export const trackProfileAction = (action, metadata = {}) => {
  trackEvent('Profile', action, null, null, metadata)
}

/**
 * Track account deletion
 */
export const trackAccountDeletion = (reason = null) => {
  trackEvent('User', 'account_deleted', reason)
}

/**
 * Track password reset
 */
export const trackPasswordReset = (method = 'email') => {
  trackEvent('User', 'password_reset', method)
}
